module.exports = __webpack_public_path__ + "static/media/yellow_chip.3e8fb475.png";